import { ReactNode } from 'react';
import { AgentPage } from '@/types/agent/agent-page';
import { DEFAULT_BRANDING } from '@/types/ui/branding';

interface HeroTemplateProps {
  agent: AgentPage;
  children: ReactNode;
}

const HeroTemplate = ({ agent, children }: HeroTemplateProps) => {
  const brand = agent?.agents?.branding?.primaryColor || agent.branding?.primaryColor || agent.brand_color || DEFAULT_BRANDING.primaryColor;
  const secondaryColor = agent?.agents?.branding?.secondaryColor || agent.branding?.secondaryColor || DEFAULT_BRANDING.secondaryColor;

  return (
    <div style={{ minHeight: '100vh', width: '100%', background: '#F9FAFC' }}>
      {/* Hero Section */}
      <div
        style={{
          background: `linear-gradient(135deg, ${brand} 0%, ${secondaryColor} 100%)`,
          padding: '80px 20px',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Decorative elements */}
        <div
          style={{
            position: 'absolute',
            top: '-50%',
            right: '-10%',
            width: '600px',
            height: '600px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '50%',
            filter: 'blur(60px)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '-30%',
            left: '-5%',
            width: '400px',
            height: '400px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '50%',
            filter: 'blur(60px)',
          }}
        />

        {/* Content */}
        <div style={{ position: 'relative', zIndex: 1, maxWidth: '800px', margin: '0 auto' }}>
          <h1
            style={{
              fontSize: 'clamp(2rem, 5vw, 3.5rem)',
              fontWeight: 'bold',
              color: '#ffffff',
              marginBottom: '1.5rem',
              lineHeight: '1.2',
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            }}
          >
            {agent.name}
          </h1>
          <p
            style={{
              fontSize: 'clamp(1.1rem, 2.5vw, 1.5rem)',
              color: 'rgba(255, 255, 255, 0.95)',
              marginBottom: '2rem',
              lineHeight: '1.6',
              maxWidth: '600px',
              margin: '0 auto',
              textShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            }}
          >
            {agent.description || agent.welcome_message || 'Start a conversation with our AI assistant'}
          </p>
        </div>
      </div>

      {/* Agent Conversation Area */}
      <div
        style={{
          maxWidth: '1200px',
          margin: '-60px auto 0',
          padding: '0 20px 60px',
          position: 'relative',
          zIndex: 2,
        }}
      >
        <div
          style={{
            background: '#ffffff',
            borderRadius: '24px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
            padding: '60px 40px',
            minHeight: '500px',
          }}
        >
          {children}
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          textAlign: 'center',
          padding: '40px 20px',
          color: '#6B7280',
          fontSize: '0.9rem',
        }}
      >
        <p>Powered by AI • Always Available • Instant Support</p>
      </div>
    </div>
  );
};

export default HeroTemplate;
